import React from "react";
import { Badge } from "@/components/ui/badge";

export function Privacy() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-16 prose">
      <Badge variant="outline" className="mb-3">Privacy</Badge>
      <h1 className="font-display text-4xl font-bold text-primary">Privacy Policy</h1>
      <p className="mt-4 text-muted-foreground">Last updated: January 2026</p>
      <div className="mt-6 space-y-4 text-sm text-muted-foreground leading-relaxed">
        <p>QuadScrub collects only the information needed to deliver student living services — names, contact details, addresses, and payment data processed by our PCI-DSS compliant payment provider (Stripe).</p>
        <p>We never sell or rent your data. We share information with our service providers only as needed to fulfill bookings (typically student name, address, and access notes).</p>
        <p>Photos taken during a service visit are stored securely and shared only with the parent on the account. Students can request deletion at any time.</p>
        <p>For data requests, contact privacy@quadscrub.com.</p>
      </div>
    </div>
  );
}

export function Terms() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-16">
      <Badge variant="outline" className="mb-3">Legal</Badge>
      <h1 className="font-display text-4xl font-bold text-primary">Terms of Service</h1>
      <p className="mt-4 text-muted-foreground">Last updated: January 2026</p>
      <div className="mt-6 space-y-4 text-sm text-muted-foreground leading-relaxed">
        <p>By using QuadScrub you agree to these terms. Bookings are subject to availability and our 24-hour reschedule policy.</p>
        <p>Recurring plans renew automatically until cancelled. You can cancel any time before the next scheduled visit from your parent dashboard.</p>
        <p>We're not responsible for damages that pre-existed before our visit — our Peace-of-Mind reports document every service to protect both parties.</p>
        <p>Questions? legal@quadscrub.com.</p>
      </div>
    </div>
  );
}
